import { __assign, __awaiter, __generator } from "tslib";
import React, { useEffect, useRef } from 'react';
import classNames from 'classnames';
import s from './preview.scss';
export var LocalVideoPreview = function (_a) {
    var _b;
    var dataHook = _a.dataHook, video = _a.video, selectedCamera = _a.selectedCamera, screenShare = _a.screenShare, onDeniedScreenShare = _a.onDeniedScreenShare, dashboard = _a.dashboard;
    var videoRef = useRef(null);
    useEffect(function () {
        setStream();
        return stopTracks;
    }, [video, selectedCamera, screenShare]);
    var stopTracks = function () {
        var _a;
        var srcObject = (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.srcObject;
        return srcObject === null || srcObject === void 0 ? void 0 : srcObject.getTracks().forEach(function (track) { return track.stop(); });
    };
    var setStream = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, e_1, constraints, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    stopTracks();
                    if (!screenShare) return [3 /*break*/, 5];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    _a = videoRef.current;
                    return [4 /*yield*/, navigator.mediaDevices.getDisplayMedia()];
                case 2:
                    _a.srcObject = _c.sent();
                    videoRef.current.srcObject.getVideoTracks()[0].onended = function () {
                        onDeniedScreenShare();
                    };
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _c.sent();
                    onDeniedScreenShare();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
                case 5:
                    if (!video) return [3 /*break*/, 8];
                    constraints = dashboard ? { facingMode: 'environment', aspectRatio: { exact: 1.7777777778 }, width: 9999 } : {};
                    _b = videoRef.current;
                    return [4 /*yield*/, navigator.mediaDevices.getUserMedia({
                            video: video ? __assign({ deviceId: selectedCamera }, constraints) : false,
                            audio: false,
                        })];
                case 6:
                    _b.srcObject = _c.sent();
                    return [4 /*yield*/, videoRef.current.play()];
                case 7:
                    _c.sent();
                    return [3 /*break*/, 9];
                case 8:
                    videoRef.current.srcObject = null;
                    _c.label = 9;
                case 9: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("video", { "data-hook": dataHook, playsInline: true, muted: true, className: classNames(s.container, (_b = {}, _b[s.screenShare] = screenShare, _b)), ref: videoRef, autoPlay: true }));
};
//# sourceMappingURL=preview.js.map